import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-eula-introduction',
  templateUrl: './eula-introduction.component.html',
  styleUrls: ['./eula-introduction.component.scss']
})
export class EulaIntroductionComponent implements OnInit {
  @Input() operator: any; 

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
  }

  goToEULA(filePath: string) {
    if (filePath.includes('/assets/files')) {
      this.http.get(filePath, { responseType: 'blob' }).subscribe((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      });
    } else window.open(filePath, "_blank");
  }

}
